/** @prettier */

/**
 * グループ削除ダイアログ
 */

import {
  FormControlLabel,
  FormGroup,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Checkbox,
} from '@mui/material';
import React, {useState} from 'react';
import {useParams} from 'react-router-dom';
import {useTranslation} from 'react-i18next';

//MTH component import
import APIErrorMessage from '../../component/APIErrorMessage';
//API import
import {
  deleteCompositionsGroups,
  getCompositionsGroups,
} from '../../API/API_Collection';
//interface import
import * as apiIF from '../../Type/api';
//Style import
import '../../css/common/common.css';

import {sortByUnicode} from '../../functions/sort';
import {PrimaryButton, SecondaryButton} from '../../component/BasicButton';

const GroupDeleteDialog = (props: {
  groupID: string;
  groupName: string;
  setGroupInfo: React.Dispatch<
    React.SetStateAction<apiIF.res.getCompositionsGroups | null>
  >;
  isOpenDialog: boolean;
  setIsOpenDialog: (arg0: boolean) => void;
}) => {
  //パスパラメータ取得
  const {siteID} = useParams();

  const [checked1, setChecked1] = useState(false); //1行目のチェックボックス
  const [checked2, setChecked2] = useState(false); //2行目のチェックボックス
  const [okBtnDisabled, setOKBtnDisabled] = useState(true); //OKボタン非表示フラグ
  const [isOpenErrorDialog, setIsOpenErrorDialog] = useState(false); //APIエラー時のエラーダイアログ表示フラグ
  const [apiWait, setAPIWait] = useState(false); //API応答待ちフラグ

  const trans = useTranslation().t; //翻訳関数

  /**
   * OKボタン押下時処理
   */
  const deleteGroup = () => {
    //パスパラメータを取得できない場合
    if (siteID === undefined) {
      return;
    }

    setOKBtnDisabled(true);
    setAPIWait(true);

    //グループを削除
    deleteCompositionsGroups(siteID, props.groupID)
      .then(() => {
        //グループの情報を取得
        return getCompositionsGroups(siteID, {'max-result': 400});
      })
      .then(response => {
        //表示内容をUnicode順に並び替え
        response['group-informations'].sort(sortByUnicode('group-name'));
        for (const info of response['group-informations']) {
          if (info['unit-informations'] === undefined) continue;
          info['unit-informations'].sort(sortByUnicode('unit-name'));
        }
        props.setGroupInfo(response);
        handleClose();
      })
      .catch(() => {
        setOKBtnDisabled(false);
        setIsOpenErrorDialog(true);
      })
      .finally(() => {
        setAPIWait(false);
      });
  };
  /**
   * CANCELボタン押下時処理
   */
  const handleClose = () => {
    props.setIsOpenDialog(false);
    setChecked1(false);
    setChecked2(false);
  };

  /**
   * チェックボックス押下時処理
   * @param event
   * @param check 押下したチェックボックスの名前
   */
  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    check: string
  ) => {
    if (check === 'check1') {
      setChecked1(event.target.checked);
      if (event.target.checked === false || checked2 === false) {
        setOKBtnDisabled(true);
      } else {
        setOKBtnDisabled(false);
      }
    }
    if (check === 'check2') {
      setChecked2(event.target.checked);
      if (event.target.checked === false || checked1 === false) {
        setOKBtnDisabled(true);
      } else {
        setOKBtnDisabled(false);
      }
    }
  };

  return (
    <>
      <Dialog
        open={props.isOpenDialog}
        onClose={handleClose}
        aria-labelledby="form-dialog-title">
        <DialogTitle>{trans('GroupDeleteDialog.title')}</DialogTitle>
        <DialogContent>
          {/*グループの名前 */}
          <DialogContentText>
            {trans('GroupDeleteDialog.msg')} {props.groupName}
          </DialogContentText>
          {/* チェックボックス */}
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={e => handleChange(e, 'check1')}
                  id={`${props.groupName}DeleteChkbox1`}
                />
              }
              checked={checked1}
              label={trans(
                'GroupDeleteDialog.checkboxDescription.deleteConfirmation'
              )}
            />
            <FormControlLabel
              control={
                <Checkbox
                  onChange={e => handleChange(e, 'check2')}
                  id={`${props.groupName}DeleteChkbox2`}
                />
              }
              checked={checked2}
              label={trans(
                'GroupDeleteDialog.checkboxDescription.registeredUnitUngrouped'
              )}
            />
          </FormGroup>
        </DialogContent>
        <DialogActions>
          <SecondaryButton
            disabled={apiWait}
            onClick={handleClose}
            buttonText={trans('GroupDeleteDialog.buttonTxt.cancel')}
            id={`mv-DeleteCancelBtn${props.groupName}`}
          />
          <PrimaryButton
            onClick={deleteGroup}
            buttonText={trans('GroupDeleteDialog.buttonTxt.ok')}
            id={`mv-DeleteOkBtn${props.groupName}`}
            disabled={okBtnDisabled}
            apiWait={apiWait}
          />
        </DialogActions>
      </Dialog>
      <APIErrorMessage
        open={isOpenErrorDialog}
        setOpen={setIsOpenErrorDialog}
        id={`mv-DeleteErrDlgBtn${props.groupName}`}
      />
    </>
  );
};
export default GroupDeleteDialog;
